import React from 'react';
import {observer} from 'mobx-react';
import {Modal, ModalButtons} from 'shared/components/modals';
import {t} from 'shared/core';
import {DatePicker, FormLayout, InputHelper, ObjectSelect2} from 'shared/components';
import {EmployeeSelector} from 'main/components';

const DuplicateGoalModal = observer(({modalOpen, uiState}) => {
  const {selectedGoal, errors} = uiState;

  return (
    <Modal
      title={t('goals.DUPLICATE_MODAL_TITLE', {name: selectedGoal.title})}
      translateTitle={false}
      size='md'
      onHide={() => uiState.closeDuplicateGoalModal()}
      isOpen={modalOpen}
    >
      <FormLayout>
        <EmployeeSelector
          label={t('goals.Assignees')}
          onChange={employees => uiState.changeDuplicateAssignees(employees)}
        />
        <InputHelper translateHelpMessage helpMessage='goals.Each assignee will get a copy of the goals and its subgoals. Subgoals will use the same assignee as the duplicated goal.'/>
        <ObjectSelect2
          label='goals.Parent Goal'
          value={selectedGoal.parentGoal}
          display='titleWithEmployeeName'
          optional={true}
          searchable={true}
          onChange={value => uiState.updateDuplicatingGoal({parentGoal: value})}
          allowClear={true}
          items={uiState.availableParentGoals}
          helpMessage='goals.PARENT_GOAL_DESCRIPTION'
          errorMessage={errors.parentGoal}
        />
        <FormLayout.Group>
          <DatePicker
            value={selectedGoal.startDate}
            onChange={date => uiState.updateDuplicatingGoal({startDate: date})}
            label='goals.Start Date'
            errorMessage={errors.startDate}
          />
          <DatePicker
            value={selectedGoal.endDate}
            onChange={date => uiState.updateDuplicatingGoal({endDate: date})}
            label='goals.End Date'
            errorMessage={errors.endDate}
          />
        </FormLayout.Group>
      </FormLayout>
      <ModalButtons
        saveCaption={'goals.Duplicate'}
        onCancel={() => uiState.closeDuplicateGoalModal()}
        onSave={() => uiState.duplicateSelectedGoal()}
      />
    </Modal>
  );
});

export default DuplicateGoalModal;
